import api from './api';

class CustomerService {
  getCustomersByRoute = async (routeId, page = 1, limit = 10, search = '') => {
    try {
      let url = `/customers/routes/${routeId}/customers?page=${page}&limit=${limit}`;
      
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
  
  createCustomer = async (customerData) => {
    try {
      const response = await api.post('/customers/create', customerData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
  
  updateCustomer = async (customerId, customerData) => {
    try {
      const response = await api.put(`/customers/edit/${customerId}`, customerData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
  
  // getCustomerById = async (customerId) => {
  //   try {
  //     const response = await api.get(`/customers/${customerId}`);
  //     return response.data;
  //   } catch (error) {
  //     throw this.handleError(error);
  //   }
  // };
  
  handleError = (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          return new Error(data.message || 'Invalid request data');
        case 401:
          return new Error('Unauthorized access');
        case 403:
          return new Error('Permission denied');
        case 404:
          return new Error('Customer not found');
        case 500:
          return new Error('Server error');
        default:
          return new Error(data.message || 'Failed to process request');
      }
    } else if (error.request) {
      return new Error('No response from server. Please check your connection.');
    } else {
      return new Error('Request error: ' + error.message);
    }
  };
}

export default new CustomerService();